import React from 'react';

interface SportIconProps {
  sport?: string;
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function SportIcon({
  sport = '',
  size = 20,
  color = 'currentColor',
  className = '',
  style = {},
}: SportIconProps) {
  const s = (sport || '').toUpperCase();

  const svgStyle: React.CSSProperties = {
    width: size,
    height: size,
    display: 'inline-block',
    verticalAlign: 'middle',
    flexShrink: 0,
    ...style,
  };

  if (s.includes('CRICKET')) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={svgStyle}
        className={className}
      >
        <path d="M5 21L14 12L17 15L8 24L5 21Z" fill={color} fillOpacity="0.15" />
        <path d="M14 12L19 7" strokeWidth="2.5" />
        <path d="M18 6L21 3" strokeWidth="3" />
        <circle cx="18" cy="18" r="3" fill={color} fillOpacity="0.2" />
        <path d="M16 17C17 17 19 19 20 20" strokeWidth="1.2" />
      </svg>
    );
  }

  if (s.includes('FOOTBALL') || s.includes('SOCCER')) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={svgStyle}
        className={className}
      >
        <circle cx="12" cy="12" r="9.5" />
        <polygon points="12,8 15,10.2 13.8,13.8 10.2,13.8 9,10.2" fill={color} fillOpacity="0.25" />
        <line x1="12" y1="2.5" x2="12" y2="8" />
        <line x1="15" y1="10.2" x2="20.5" y2="8.5" />
        <line x1="13.8" y1="13.8" x2="18" y2="18.5" />
        <line x1="10.2" y1="13.8" x2="6" y2="18.5" />
        <line x1="9" y1="10.2" x2="3.5" y2="8.5" />
      </svg>
    );
  }

  if (s.includes('BASKETBALL')) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={svgStyle}
        className={className}
      >
        <circle cx="12" cy="12" r="9.5" />
        <line x1="2.5" y1="12" x2="21.5" y2="12" />
        <line x1="12" y1="2.5" x2="12" y2="21.5" />
        <path d="M5.5 5.5C8.8 8.8 8.8 15.2 5.5 18.5" />
        <path d="M18.5 5.5C15.2 8.8 15.2 15.2 18.5 18.5" />
      </svg>
    );
  }

  if (s.includes('BADMINTON')) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={svgStyle}
        className={className}
      >
        <circle cx="12" cy="18" r="3" fill={color} fillOpacity="0.25" />
        <path d="M9.5 16L6 5C6 5 12 7 12 7C12 7 18 5 18 5L14.5 16" />
        <line x1="8" y1="10" x2="16" y2="10" />
        <line x1="7" y1="13" x2="17" y2="13" />
        <line x1="12" y1="7" x2="12" y2="15" />
      </svg>
    );
  }

  if (s.includes('TENNIS')) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={svgStyle}
        className={className}
      >
        <circle cx="12" cy="12" r="9.5" />
        <path d="M4.5 7.5C8.5 8.5 10 13 9 19.5" />
        <path d="M19.5 16.5C15.5 15.5 14 11 15 4.5" />
      </svg>
    );
  }

  if (s.includes('VOLLEYBALL')) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={svgStyle}
        className={className}
      >
        <circle cx="12" cy="12" r="9.5" />
        <path d="M12 2.5C12 7.5 16 11 21.5 11" />
        <path d="M2.5 13C8 13 11.5 16.5 12 21.5" />
        <path d="M5.5 5.5C9 8.5 10.5 13 8 18.5" />
      </svg>
    );
  }

  if (s.includes('PICKLEBALL') || s.includes('TABLE') || s.includes('PING')) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={svgStyle}
        className={className}
      >
        <ellipse cx="14" cy="9.5" rx="6.5" ry="7.5" fill={color} fillOpacity="0.15" />
        <line x1="9" y1="15" x2="4" y2="20" strokeWidth="2.5" />
        <circle cx="13" cy="8" r="0.8" fill={color} />
        <circle cx="15" cy="8" r="0.8" fill={color} />
        <circle cx="14" cy="11" r="0.8" fill={color} />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={svgStyle}
      className={className}
    >
      <circle cx="12" cy="12" r="9.5" />
      <polygon points="12 6 13.8 9.8 18 10.4 15 13.3 15.7 17.5 12 15.5 8.3 17.5 9 13.3 6 10.4 10.2 9.8 12 6" fill={color} fillOpacity="0.2" />
    </svg>
  );
}
